<template>
  <!--资料-->
  <div class="ziliao">
      <Tabs >
        <TabPane label="我的资料" key="key1">


            <div class="formWrapper">
              <Form :label-width="120" ref="formCustom" :model="formCustom" :rules="ruleCustom">
                <FormItem label="姓名" prop="names">
                  <Input  value="张三" readonly="true"/>
                </FormItem>
                <FormItem label="性别 ">
                  <Input  value="男" readonly="true"/>
                </FormItem>
                <FormItem label="证件类型 ">
                  <Input  value="身份证" readonly="true"/>
                </FormItem>
                <FormItem label="证件号码  ">
                  <Input  value="215254199005123223" readonly="true"/>
                </FormItem>
                <FormItem label="出生年月  ">
                  <Input  value="1990-05-12" readonly="true"/>
                </FormItem>
                <FormItem label="民族(字典)">
                  <Input  value="汉" readonly="true"/>
                </FormItem>
               <FormItem label="国籍(字典)">
                 <Input  value="中国" readonly="true"/>
               </FormItem>
                <FormItem label="省份/城市">
                  <Input  value="广东省/深圳市" readonly="true"/>
                </FormItem>
                <FormItem label="政治面貌(字典)">
                  <Input  value="党员" readonly="true"/>
                </FormItem>
                <FormItem label="通讯地址">
                  <Input  value="深圳市南山区海德大道100号" readonly="true"/>
                </FormItem>
                <FormItem label="联系方式">
                  <Input  value="18600669988" readonly="true"/>
                </FormItem>
                <FormItem label="电子邮箱">
                  <Input  value="123456@qq.com" readonly="true"/>
                </FormItem>

              </Form>
            </div>


        </TabPane>
        <TabPane label="教育经历">
          <div class="formWrapper">
            <Form :label-width="135" ref="formCustom" :model="formCustom" :rules="ruleCustom">
              <FormItem label="最高学历  " prop="names">
                <Input  value="本科" readonly="true"/>
              </FormItem>
              <FormItem label="院校名称   ">
                <Input  value="深圳大学" readonly="true"/>
              </FormItem>
              <FormItem label="在校生/已有学历   ">
                <Input  value="已有学历 " readonly="true"/>
              </FormItem>
              <FormItem label="证书编号/学籍号  ">
                <Input  value="102154790" readonly="true"/>
              </FormItem>
              <FormItem label="毕业时间   ">
                <Input  value="2015-06-30" readonly="true"/>
              </FormItem>
              <FormItem label="所学专业  ">
                <Input  value="物业管理" readonly="true"/>
              </FormItem>
              <FormItem label="学制  ">
                <Input  value="四年" readonly="true"/>
              </FormItem>
              <FormItem label="学位  ">
                <Input  value="学士" readonly="true"/>
              </FormItem>
            </Form>
          </div>
        </TabPane>
        <TabPane label="工作经历">
          <div class="formWrapper">
            <Form :label-width="120" ref="formCustom" :model="formCustom" :rules="ruleCustom">
              <FormItem label="行业类型 " prop="names">
                <Input  value="互联网" readonly="true"/>
              </FormItem>
              <FormItem label="工作单位  ">
                <Input  value="美达中国" readonly="true"/>
              </FormItem>
              <FormItem label="企业类型  ">
                <Input  value="私企 " readonly="true"/>
              </FormItem>
              <FormItem label="部门  ">
                <Input  value="产品部" readonly="true"/>
              </FormItem>
              <FormItem label="职位/岗位   ">
                <Input  value="经理" readonly="true"/>
              </FormItem>
              <FormItem label="工作时间 ">
                <Input  value="五年" readonly="true"/>
              </FormItem>
            </Form>
          </div>
        </TabPane>
        <Tab-pane label="培训经历" key="key3" class="changephone">
          <div class="formWrapper">
            <Form :label-width="120" ref="formCustom" :model="formCustom" :rules="ruleCustom">
              <FormItem label="培训机构  " prop="names">
                <Input  value="清华大学商学院" readonly="true"/>
              </FormItem>
              <FormItem label="机构代码   ">
                <Input  value="236442010" readonly="true"/>
              </FormItem>
              <FormItem label="证书编号  ">
                <Input  value="236442010 " readonly="true"/>
              </FormItem>
              <FormItem label="培训课程  ">
                <Input  value="物业管理" readonly="true"/>
              </FormItem>
              <FormItem label="学时   ">
                <Input  value="30" readonly="true"/>
              </FormItem>

            </Form>
          </div>
        </Tab-pane>
      </Tabs>
    <router-view ></router-view>
  </div>
</template>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less" rel="stylesheet/less">

.formWrapper{
  width: 330px;
}

</style>
<script type="text/ecmascript-6">

    export default {
        name: '',
        props: {},
        data() {

            return {

            }
        },
        methods: {
         
        },
        created() {
         
        },
      mounted(){

      },

    }
</script>



// WEBPACK FOOTER //
// src/components/center/kaoshiziliao.vue